import { render, staticRenderFns } from "./TractVisitTypeSettings.vue?vue&type=template&id=35341727&"
import script from "./TractVisitTypeSettings.vue?vue&type=script&lang=js&"
export * from "./TractVisitTypeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports